<template>
  <v-layout row justify-center>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-dialog v-model="dialog" persistent max-width="1100">
      <v-card>
        <v-card-title class="headline info white--text"
          >Satış Fatura</v-card-title
        >
        <v-card-text>
          <v-flex xs12 sm12 md12>
            <v-layout row wrap>
              <v-flex xs12 sm3 md3>
                <tarihim
                  v-model="listParams.Tarih1"
                  :etiket="'Baslangic'"
                  :detaygizle="false"
                  v-bind:defaultvalue="'ok'"
                >
                </tarihim>
              </v-flex>
              <v-flex xs12 sm3 md3>
                <tarihim
                  v-model="listParams.Tarih2"
                  :etiket="'Bitis'"
                  :detaygizle="false"
                  v-bind:defaultvalue="'ok'"
                >
                </tarihim>
              </v-flex>
              <v-flex xs12 sm3 md2>
                <v-text-field
                  :label="$t('Invoice-Serial')"
                  v-model="listParams.SeriNo"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  :label="$t('Invoice-No')"
                  v-model="listParams.FaturaNo"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 md3>
                <pnrbul hide-details v-model="listParams.PNR_No"> </pnrbul>
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  :label="$t('Guest')"
                  v-model="listParams.DE"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 md4>
                <cariaracomp
                  v-bind:etiket="$t('Select-Counter-Current')"
                  v-model="listParams.CariKod"
                  v-bind:Coper="true"
                ></cariaracomp>
              </v-flex>
              <v-flex xs12 sm3 md2>
                <v-btn round color="info" dark @click="getList()"> {{ $t('Search') }} </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 sm12 md12>
            <v-data-table
              :headers="billHeaders"
              :items="billItems"
              hide-actions
              class="elevation-1"
              item-key="FaturaNo"
            >
              <template slot="items" slot-scope="props">
                <tr @click="selectBill(props.item)">
                  <td class="text-xs-left">{{ props.item.FaturaNo }}</td>
                  <td class="text-xs-left">{{ props.item.PNR_No }}</td>
                  <td class="text-xs-left">
                    {{ props.item.Tarih | dateformat }}
                  </td>
                  <td class="text-xs-left">{{ props.item.SeriNo }}</td>
                  <td class="text-xs-left">{{ props.item.GenelFatId }}</td>
                  <td class="text-xs-left">{{ props.item.CariKod }}</td>
                  <td class="text-xs-left">{{ props.item.CariAd }}</td>
                  <td class="text-xs-left">{{ props.item.Misafir }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click.native="dialog = false"
            > {{ $t('Close') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import cariaracomp from "@/components/app/customcomp/cariaracomp";
import tool from "@/components/app/coper/tools";
import helpers from "@/components/app/customcomp/helpers.js";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";

export default {
  data() {
    return {
      billHeaders: [
        {
          text: "Fatura No",
        },
        {
          text: this.$t('PNR-No'),
        },
        {
          text: "Tarih",
        },
        {
          text: "Seri No",
        },
        {
          text: "Genel Fatura Id",
        },
        {
          text: "Cari Kod",
        },
        {
          text: "Cari Ad",
        },
        {
          text: this.$t('Guest'),
        },
      ],
      billItems: [],
      text1: "",
      snackbar: false,
      dialog: false,
      listParams: {
        FaturaNo: null,
        PNR_No: 0,
        Tarih1: null,
        Tarih2: null,
        SeriNo: null,
        CariKod: null,
        CariAd: null,
        Misafir: null,
      },
    };
  },
  methods: {
    selectBill(val) {
      this.$emit("changeSatisFat", val);
      this.dialog = false;
    },
    getList() {
      let params = this.listParams;
      tool.http_post(this, "SatisFaturasiAra", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.billItems = response.body.data;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = this.$t('An-error-has-occurred-Please-try-again');
          this.snackbar = true;
        }
      );
    },
    open() {
      this.dialog = true;
    },
  },
  components: {
    pnrbul,
    tarihim,
    cariaracomp,
    snackbarcomp,
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
  },
};
</script>

<style>
</style>